import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MobileLayout from "../MobileLayout";
import MobileContactsList from "./MobileContactsList";
import MobileContactDrawer from "./MobileContactDrawer";

/**
 * Mobile route for /contacts and /contacts/:contactID.
 * - Always shows the list.
 * - If :contactID is present, shows a right drawer on top.
 *
 * NOTE: When opened from another background route (e.g. /contacts/new),
 * App-level modal routing will render only the drawer, not this page.
 */
export default function MobileContactsPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { contactID } = useParams();

  const open = Boolean(contactID);

  const handleOpenContact = (id) => {
    navigate(`/contacts/${id}`, {
      state: { backgroundLocation: location },
    });
  };

  const handleCloseDrawer = () => {
    // If there is a background route, Back should close the drawer.
    if (location.state?.backgroundLocation) {
      navigate(-1);
      return;
    }
    navigate("/contacts");
  };

  return (
    <MobileLayout title="Contacts">
      <MobileContactsList onOpenContact={handleOpenContact} />
      <MobileContactDrawer
        open={open}
        contactID={contactID}
        onClose={handleCloseDrawer}
      />
    </MobileLayout>
  );
}


